<template>
  <div class="statement"  :style="`background: url('${require('../assets/bg20.png')}'); background-size: 100% 100%;`">
   <img class="sub-logo2" src="../assets/logo5.png">
  <div class="content">
    <div class="body">
        <div class="intro">
         <div class="title">
            <img  src="../assets/head2.png" >
          </div>
          <div class="content">
            <div class="contentInner">
                <!-- <img  src="../assets/intro.png" > -->
                <p>焦虑？恐慌？烦躁？关注疫情，也要关注心理健康。为身体做防护的同时，别让心理防线被攻破。
</p>
                <p>2020年1月27日，国家卫健委印发的《新型冠状病毒感染的肺炎疫情紧急心理危机干预指导原则》，除确诊和疑似患者等，连医护及相关人员也被列入当中，这标志着中国正式启动了对所有敏感人群提供心理健康保护的指南。
</p>
                <p>为了解新型冠状病毒肺炎对我们的心理影响，更加积极地应对疫情，星空学院特开设 “医务人员心理关爱”板块，以助力打赢心理防疫战。
</p>
                <p class="colorBlue">《症状自评量表SCL90》介绍：</p>
                <p>《症状自评量表SCL90》是世界上最著名的心理健康测试量表之一，是当前使用最为广泛的精神障碍和心理疾病门诊检查量表，该自评量表具有容量大、反映症状丰富、更能准确刻画被试的自觉症状等特点。将协助您从十个方面来了解自己的心理健康程度。本测验共有90个项目，包含有较广泛的精神病症状学内容，从感觉、情感、思维、意识、行为直至生活习惯、人际关系、饮食睡眠等，均有涉及，并采用10个因子分别反映10个方面的心理症状情况。
</p>
                <p class="colorBlue">《焦虑自评量表-SAS》介绍：</p>
                <p>焦虑自评量表，用于评定病人焦虑的主观感受及其在治疗中的变化，SAS适用于具有焦虑症状的成年人，具有广泛的应用性。
</p>
                <p class="colorBlue">《抑郁自评量表-SDS》介绍：</p>
                <p>抑郁自评量表含有20个项目，分为4级评分的自评量表，其特点是使用简便，并能相当直观地反映抑郁患者的主观感受及其在治疗中的变化，当前已广泛应用于病情的粗筛、情绪状态评定以及调查、科研等。 
</p>
                <p>疫情当前，我们每个人都要相信：爱和希望，一定比病毒蔓延更快。众志成城，抗疫必胜！</p>
            </div>
          </div>
          <div class="bottom">
             <!-- <div class="goLine"></div> -->
             <img class="go" src="../assets/go2.png" @click="goQuestion()">
          </div>
        </div>
    </div>
  </div>
  <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
import Cookies from 'js-cookie'

import axios from 'axios'


export default {
  name: 'Question1',
  data() {
    return {
        id: 1
    };
  },

  methods: {
    goQuestion(){
        //this.$router.push({ name: "QuestionList" })
        const id = this.id
         switch(id){
            case 1: 
                this.$router.push({ name: "Question1" })
                break;
            case 2: 
                this.$router.push({ name: "Question2" })
                break;
            case 3: 
                this.$router.push({ name: "Question3" })
                break;
        }
    },
  },
  mounted: function() {
      this.id = parseInt(this.$route.query.id)
  }

};
</script>

<style lang="less">
.statement {
  font-size: 16px;
    display: flex;
    height: 100vh;
    flex-direction: column;

     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
  .content {
    position: relative;
    overflow: hidden;
    height: 90%;
    background-color: #fff;
    margin: 60px 20px;
    
    .body {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        // overflow-y: scroll;
        .intro {
            border-radius: 4px;
            img {
                width: 100%;
            }
            .title {
            width: 100%;
            margin-bottom: 24px;
            }
            .colorBlue {
                color: #34afe8;
            }
            height: 100%;
            .content{
                font-size: 12px;
                line-height: 18px;
                height: 60%;
                position: relative;
                overflow: hidden;
                margin: 0 20px;
                word-break: break-all;
                .contentInner {
                    position: absolute;
                    left: 0;
                    top: 0;
                    // right: -17px;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: scroll;
                }
            }

            .bottom {
                // display: flex;
                // position: relative;
                // margin-top: 24px;
                // .goLine {
                //     width: 60%;
                //     flex: 0 0 60%;
                //     margin-left: 10%;
                //     // width: 60%;
                //     height: 1px;
                //     border-top: solid #33b0e6 1px;
                //     margin-bottom: 24px;
                // }
                .go {
                    width: 100%;
                    // width: 100px;
                    // position: absolute;
                    // right: 0;
                    // bottom: 8px;
                    // margin-right: 4%;
                }
            }
        }
    }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Statement.vue